import * as PropTypes from 'prop-types';
import * as React from 'react';

import ProductDetails from './product_details';
import { updatePrices, updateFreeShipping } from './bundled_product_updater';
import TaxWillBeAddedNotice from './tax_will_be_added_notice';
import PriceFieldWithCurrency from '../shared/price_field_with_currency';
import Tooltip from '../tooltip';


class BundleInfoForm extends React.Component {
  static propTypes = {
    bundledProduct: PropTypes.object.isRequired,
    remove: PropTypes.func.isRequired,
    userCurrency: PropTypes.string.isRequired,
    errorMessage: PropTypes.string,
    index: PropTypes.number.isRequired,
    bundledProductChanged: PropTypes.func.isRequired,
  };

  errorMessage = () => {
    if (this.props.bundledProduct.errorMessage) {
      return <p className="alert alert-error">{this.props.bundledProduct.errorMessage}</p>;
    }
  };

  priceChanged = (e) => {
    this.props.bundledProductChanged(
      updatePrices(this.props.bundledProduct, e.target.value),
      this.props.index,
    );
  };

  freeShippingChanged = (e) => {
    this.props.bundledProductChanged(
      updateFreeShipping(this.props.bundledProduct, e.target.checked),
      this.props.index,
    );
  };

  idField = () => {
    if (this.props.bundledProduct.id) {
      return (
        <input
          type="hidden"
          value={this.props.bundledProduct.id}
          name={`product_bundle[bundled_products_attributes][${this.props.index}][id]`}
        />
      );
    }
  };

  render() {
    return (
      <div className="module bd-rounded bundle-form mb-1">
        <div className="g-container">
          <div className="g-col-6">
            <h4 className="heading-3 mb-half">
              {I18n.t('js.productBundles.bundleInfoForm.bundledListing')}
            </h4>
          </div>
          <div className="g-col-6 align-right">
            <Tooltip title={I18n.t('js.productBundles.bundleInfoForm.removeAddOn')}>
              <a
                onClick={() => {
                  this.props.remove(this.props.index);
                }}
              >
                <span className="fa fa-times" />
              </a>
            </Tooltip>
          </div>
        </div>
        {this.errorMessage()}
        {this.idField()}
        <input
          type="hidden"
          value={this.props.bundledProduct.listing.id}
          name={`product_bundle[bundled_products_attributes][${this.props.index}][listing_id]`}
        />
        <ProductDetails
          product={this.props.bundledProduct.listing}
          newPrice={
            (this.props.bundledProduct.listing.price &&
              this.props.bundledProduct.listing.price.amount) ||
            0
          }
          originalPrice={this.props.bundledProduct.listing.original_price}
        />
        <hr className="mtb-1" />
        <div className="g-container">
          <div className="g-col-4 g-col-mobile-12">
            <div className="form-group">
              <div className="form-group__header">
                <label htmlFor="price">
                  {I18n.t('js.productBundles.bundleInfoForm.priceLabel')}{' '}
                  <Tooltip
                    className="muted"
                    title={I18n.t('js.productBundles.bundleInfoForm.priceLabelTooltip')}
                  />
                </label>
              </div>
              <div className="form-group__fields">
                <PriceFieldWithCurrency
                  currency={this.props.userCurrency}
                  name={`product_bundle[bundled_products_attributes][${this.props.index}][price]`}
                  value={
                    this.props.bundledProduct.listing.price &&
                    this.props.bundledProduct.listing.price.amount
                  }
                  onChange={this.priceChanged}
                />
              </div>
            </div>
          </div>
          <div className="g-col-7 g-offset-1 g-col-mobile-12 g-offset-mobile-0">
            <div className="form-group">
              <div className="form-group__header">
                <label>
                  {I18n.t('js.productBundles.bundleInfoForm.shippingLabel')}{' '}
                  <Tooltip
                    className="muted"
                    title={I18n.t('js.productBundles.bundleInfoForm.shippingLabelTooltip')}
                  />
                </label>
              </div>
              <div className="form-group__fields">
                <input
                  type="hidden"
                  name={`product_bundle[bundled_products_attributes][${
                    this.props.index
                  }][free_shipping]`}
                  value="0"
                />
                <div className="label-with-checkbox mt-1">
                  <input
                    type="checkbox"
                    name={`product_bundle[bundled_products_attributes][${
                      this.props.index
                    }][free_shipping]`}
                    id={`product_bundle[bundled_products_attributes][${
                      this.props.index
                    }][free_shipping]`}
                    checked={this.props.bundledProduct.free_shipping}
                    onChange={this.freeShippingChanged}
                  />
                  <label
                    htmlFor={`product_bundle[bundled_products_attributes][${
                      this.props.index
                    }][free_shipping]`}
                  >
                    {I18n.t('js.productBundles.bundleInfoForm.freeShipping')}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <TaxWillBeAddedNotice
          showNotice={this.props.bundledProduct.listing.buyer_price.tax_included}
        />
      </div>
    );
  }
}

export default BundleInfoForm;



// WEBPACK FOOTER //
// ./javascripts/components/product_bundles/bundle_info_form.jsx